// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/portal_service.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { PortalEventServiceAssignSeatRequest, PortalEventServiceAssignSeatResponse, PortalEventServiceGetEventsByBrandIdRequest, PortalEventServiceGetEventsByBrandIdResponse, PortalEventServiceGetTicketAvailableConsecutiveCountRequest, PortalEventServiceGetTicketAvailableConsecutiveCountResponse, PortalEventServiceGetTicketsBonusMediaRequest, PortalEventServiceGetTicketsBonusMediaResponse, PortalEventServiceReleaseSeatRequest, PortalEventServiceReleaseSeatResponse, PortalEventServiceReserveSeatRequest, PortalEventServiceReserveSeatResponse } from "./portal_service_pb";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";
/**
 * @generated from service spwn.event.v1.PortalEventService
 */
export const PortalEventService = {
    typeName: "spwn.event.v1.PortalEventService",
    methods: {
        /**
         * イベント一覧の取得
         *
         * @generated from rpc spwn.event.v1.PortalEventService.GetEventsByBrandId
         */
        getEventsByBrandId: {
            name: "GetEventsByBrandId",
            I: PortalEventServiceGetEventsByBrandIdRequest,
            O: PortalEventServiceGetEventsByBrandIdResponse,
            kind: MethodKind.Unary,
        },
        /**
         * チケットに紐づく特典一覧の取得
         *
         * @generated from rpc spwn.event.v1.PortalEventService.GetTicketsBonusMedia
         */
        getTicketsBonusMedia: {
            name: "GetTicketsBonusMedia",
            I: PortalEventServiceGetTicketsBonusMediaRequest,
            O: PortalEventServiceGetTicketsBonusMediaResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.event.v1.PortalEventService.ReserveSeat
         */
        reserveSeat: {
            name: "ReserveSeat",
            I: PortalEventServiceReserveSeatRequest,
            O: PortalEventServiceReserveSeatResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.event.v1.PortalEventService.ReleaseSeat
         */
        releaseSeat: {
            name: "ReleaseSeat",
            I: PortalEventServiceReleaseSeatRequest,
            O: PortalEventServiceReleaseSeatResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.event.v1.PortalEventService.AssignSeat
         */
        assignSeat: {
            name: "AssignSeat",
            I: PortalEventServiceAssignSeatRequest,
            O: PortalEventServiceAssignSeatResponse,
            kind: MethodKind.Unary,
        },
        /**
         * チケットに紐づく連番を考慮した最大購入可能数の取得
         *
         * @generated from rpc spwn.event.v1.PortalEventService.GetTicketAvailableConsecutiveCount
         */
        getTicketAvailableConsecutiveCount: {
            name: "GetTicketAvailableConsecutiveCount",
            I: PortalEventServiceGetTicketAvailableConsecutiveCountRequest,
            O: PortalEventServiceGetTicketAvailableConsecutiveCountResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=portal_service_connect.js.map